// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__2fUA_","inputWrap":"styles_inputWrap__3aiF_","input":"styles_input__1Vtih"};